import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";

const vows = [
  ["Sigilo", "O que é dito na leitura fica entre você e as cartas."],
  ["Escuta", "Cada pergunta é lida com tempo, sem respostas prontas."],
  ["Clareza", "Linguagem simples para você sair com direção."],
];

export const Ritual = ({ onBook }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  return (
    <section id="sobre" ref={ref} data-testid="ritual-section" className="relative overflow-hidden bg-[#0d0519] py-24 md:py-36">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 md:px-10 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <div className="arch relative aspect-[4/5] w-full overflow-hidden border border-white/10">
            <motion.img style={{ y }} src="/img/hands.jpg" alt="Mãos sobre uma bola de cristal" className="absolute inset-0 h-[124%] w-full -translate-y-[12%] object-cover" />
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,transparent_30%,#080312_95%)]" />
          </div>
        </Reveal>
        <div className="lg:col-span-6 lg:col-start-7">
          <Reveal>
            <Eyebrow>O ritual</Eyebrow>
            <h2 className="font-display mt-6 text-5xl leading-[0.95] tracking-tight text-[#F5F2EB] md:text-6xl">
              Uma mesa posta <em className="gold-text">só para você.</em>
            </h2>
            <p className="mt-8 max-w-lg text-base leading-relaxed text-white/75">
              As cartas são embaralhadas e abertas pensando nas suas perguntas. A leitura é enviada no WhatsApp, com fotos da tiragem e a interpretação de cada arcano.
            </p>
          </Reveal>
          <div className="mt-12 grid gap-6 sm:grid-cols-3">
            {vows.map(([t, d], i) => (
              <Reveal key={t} delay={0.1 + i * 0.1}>
                <div data-testid={`vow-${i}`} className="border-l border-[#CBA365]/40 pl-5">
                  <p className="font-display text-2xl italic text-[var(--gold)]">{t}</p>
                  <p className="mt-2 text-sm leading-relaxed text-white/70">{d}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.3}>
            <button data-testid="ritual-book-btn" onClick={() => onBook()}
              className="mt-12 rounded-full border border-[var(--gold)] px-8 py-4 text-sm font-semibold uppercase tracking-[0.18em] text-[var(--gold)] transition-colors duration-300 hover:bg-[var(--gold)] hover:text-[#080312]">
              Abrir minha leitura
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
